import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const SETTINGS_PANE_CLASS_NAME = 'SettingsPane';
export const SETTINGS_PANE_CLASS_SLOTS = ['root', 'row'] as const;

export type SettingsPaneClassSlot = (typeof SETTINGS_PANE_CLASS_SLOTS)[number];

export interface SettingsPaneClasses {
	root: string;
	row: string;
}

export type SettingsPaneClassKey = keyof SettingsPaneClasses;

export const getSettingsPaneUtilityClass = (slot: string) =>
	generateUtilityClass(SETTINGS_PANE_CLASS_NAME, slot);

export const settingsPaneClasses = generateUtilityClasses<
	keyof SettingsPaneClasses
>(SETTINGS_PANE_CLASS_NAME, ['root', 'row']);
export default settingsPaneClasses;
